export default __webpack_public_path__ + "static/media/443.f4befb9e.gif";